import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonProjectProcessOverview, CommonProjectProcessTopics } from "../../CommonComponents/CommonProjectProcessViews";

export const ProjectProcessChildStepTemplatesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().process.childStepTemplates,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectProcessOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectProcessTopics />;
    },
};
